import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { logOut } from 'actions/user';

interface UseLogOut {
  logOutHandler: VoidFunction;
}

const useLogOut = (): UseLogOut => {
  const dispatch = useDispatch();
  const logOutHandler = useCallback(() => dispatch(logOut()), [dispatch]);

  return { logOutHandler };
};

export default useLogOut;
